import { DataResponse } from '@/models/api/common'
import { useQuery } from '@/hooks'
import { DashboardResponse } from '@/models/dashboard/dashboard'

export type DashboardSummaryParams = {
  /** Legacy single day (YYYY-MM-DD); used if no range/year/scope. */
  date?: string
  dateFrom?: string
  dateTo?: string
  /** Gregorian calendar year (YYYY). */
  year?: string
  scope?: 'all'
  location?: string
}

export const useGetDashboard = (params?: DashboardSummaryParams) => {
  return useQuery<DataResponse<DashboardResponse>>({
    queryKey: [
      'dashboard',
      params?.date,
      params?.dateFrom,
      params?.dateTo,
      params?.year,
      params?.scope,
      params?.location ?? '',
    ],
    url: '/bills/dashboard-summary',
    axiosConfig: {
      params: {
        date: params?.date,
        date_from: params?.dateFrom,
        date_to: params?.dateTo,
        year: params?.year,
        scope: params?.scope,
        location: params?.location || undefined,
      },
    },
  })
}

export const useGetDashboardChart = ({
  timeRange,
  location,
}: {
  timeRange?: string
  location?: string
}) => {
  return useQuery<
    DataResponse<
      {
        date: string
        buy: number
        sell: number
        buyCount: number
        sellCount: number
        buyKg: number
        sellKg: number
        name: string
        cycle_id: string
        expenses?: number
        net?: number
      }[]
    >
  >({
    queryKey: ['dashboard_chart', timeRange, location ?? ''],
    url: '/bills/chart-data',
    axiosConfig: {
      params: {
        time_period: timeRange,
        location: location || undefined,
      },
    },
  })
}
